import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

type DeleteFeeModalProps = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  isLoading: boolean;
};

export const DeleteFeeModal: FC<DeleteFeeModalProps> = (props) => {
  const { open, onClose, onDelete, isLoading } = props;
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: '380px' } }}>
      <DialogTitle>{t('fees.modals.delete.title')}</DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>{t('fees.modals.delete.text')}</DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={() => onDelete()} disabled={isLoading}>
          {t('fees.modals.delete.delete-btn')}
        </Button>
        <Button variant="outlined" onClick={() => onClose()}>
          {t('fees.modals.cancel-btn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
